import bindTable from './bindTable'
import { SCHEDU_SEARCH_CONFIG_STATUS } from '@/common/schedule/Search'

export default function () {
  const bindtb = bindTable.call(this)
  return [
    // 编号
    bindtb[0],
    // 客户
    bindtb[1],
    // 描述
    bindtb[4],
    // 操作
    bindtb[5]
  ]
}

export const searchCondi = [
  {
    id: 1,
    text: $t('integration.trunk_number'),
    type: 'input',
    paramsName: 'code',
    isChooze: true
  },
  {
    id: 4,
    text: $t('integration.relay_type'),
    type: 'select',
    paramsName: 'type',
    selectParam: [],
    isChooze: false
  },
  {
    id: 2,
    text: $t('integration.state'),
    type: 'select',
    paramsName: 'status',
    isChooze: false,
    selectParam: [
      {
        value: '',
        icon: 'el-icon-thumb',
        label: 'public.please'
      },
      {
        value: 0,
        icon: 'iconfont icon-wu-WiFi',
        label: 'selectMsg.Offline'
      },
      {
        value: 1,

        icon: 'iconfont icon-wifi',
        label: 'selectMsg.Online'
      }
    ]
  },
  SCHEDU_SEARCH_CONFIG_STATUS
]
